import React from 'react';
import {Availability} from '@bonprix/design-system';


export default function CartItemAvailability({
    texts,
    showMessageNotDeliverableToPickUpLocation,
    deliverable,
    deliverableMessage,
    tempSold,
    hints = []
}) {
    // default sold-out -> no display or only if message is present
    let delivery = 'sold-out';
    if (deliverable && tempSold) {
        delivery = 'available-soon'
    } else if (deliverable && !tempSold) {
        delivery = 'available'
    }

    if (showMessageNotDeliverableToPickUpLocation && !deliverableMessage) {
        deliverableMessage = texts.cot09_not_deliverable_to_parcelshop;
    }

    const isAlmostSoldOut = hints?.includes('LESS10') || false;

    return (
        deliverableMessage && (
            <div className='cart-item-details__availability-message'>
                <Availability delivery={delivery} almostSoldOut={isAlmostSoldOut}>
                    {deliverableMessage}
                </Availability>
            </div>
        )
    );
}
